import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputAdornment, IconButton } from "@mui/material";
import { Clear } from "@mui/icons-material";
import Button from "../ui/button/Button";
import { ADD_NOTIFICATION } from "../../store/types";
import { useDispatch } from "react-redux";
import moment from "moment";
import { toDisplayTime, toSaveDate } from "../../utilis/date-formats";

const PauseDateDialog = ({
	open,
	onClose,
	onSave,
	title,
	initialDate = null,
	loading = false,
	showSuccessNotification = true
}) => {
	const [pauseDate, setPauseDate] = useState(initialDate);
	const dispatch = useDispatch();
	
	useEffect(() => {
		setPauseDate(initialDate);
	}, [initialDate]);

	const handleSave = async () => {
		try {
			await onSave(pauseDate ? toSaveDate(pauseDate) : null);

			if (showSuccessNotification) {
				const message = pauseDate 
					? "Pause date set successfully." 
					: "Pause date cleared successfully.";
					
				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						type: "success",
						label: message,
						id: "pauseDateSuccess",
					},
				});
			}

			handleClose();
		} catch (error) {
			// Error handling is done by the parent component
		}
	};

	const handleClose = () => {
		setPauseDate(initialDate);
		onClose();
	};

	const handleDateChange = (e) => {
		const date = e.target.value ? moment(e.target.value).toDate() : null;
		setPauseDate(date);
	};

	const handleClearDate = () => {
		setPauseDate(null);
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth="sm"
			fullWidth
		>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<div style={{ marginTop: "16px", marginBottom: "16px" }}>
					<TextField
						label="Pause Date"
						type="date"
						value={pauseDate ? toDisplayTime(pauseDate, "YYYY-MM-DD") : ''}
						onChange={handleDateChange}
						fullWidth
						InputLabelProps={{
							shrink: true,
						}}
						helperText="Leave empty to clear the pause date"
						InputProps={{
							endAdornment: pauseDate && (
								<InputAdornment position="end">
									<IconButton
										onClick={handleClearDate}
										edge="end"
										size="small"
										aria-label="clear date"
									>
										<Clear />
									</IconButton>
								</InputAdornment>
							),
						}}
					// inputProps={{
					// 	min: new Date().toISOString().split('T')[0]
					// }}
					/>
				</div>
			</DialogContent>
			<DialogActions>
				<Button
					action={handleClose}
					buttonStyle="secondary"
					text="Cancel"
					size="medium"
				/>
				<Button
					action={handleSave}
					buttonStyle="theme"
					text={loading ? "Saving..." : (pauseDate ? "Save" : "Clear Pause Date")}
					size="medium"
					disabled={loading}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default PauseDateDialog;
